import React from "react";

function Description() {
	return (
		<div className="Description">
			<div>
				<img
					src={`${process.env.PUBLIC_URL}/Toppers.png`}
					alt="Mount Baker Toppers Logo"
					style={{ maxWidth: "100%", height: "auto" }}
				/>
			</div>
			<h1>FREE POP-UP ALL VOICES CHORUS</h1>
			<ul>
				<li>Meet new people</li>
				<li>Learn from award-winning teachers</li>
				<li>Fun opportunity to sing with others</li>
				<li>Perform with a large community of singers</li>
			</ul>
			<h2>Rehearse with us:</h2>
			<p>
				Every Tuesday from 7-8:30 for 6 weeks at the Majestic Ballroom-
				<br />
				1027 N Forest St, Bellingham
				<br />
				May 14 through June 18
			</p>
			<h2>Perform with the Toppers at The Fairhaven Green on</h2>
			<p>June 22 in the annual Night Of A Cappella</p>
			<div
				style={{
					backgroundColor: "#FFD700",
					padding: "1rem",
					marginTop: "1rem",
				}}>
				<strong>Save Your Spot!</strong>
			</div>
		</div>
	);
}

export default Description;
